// extracted by mini-css-extract-plugin
export default {"applePay":"apple-pay_applePay__evAIV"};